<template>
  <ClientOnly>
    <UCard
      v-if="cookies.show_cookie_banner"
      :ui="{
        root: 'z-30 fixed max-w-[500px] bottom-0 right-0 max-md:m-1 md:m-6',
        header: 'font-semibold text-lg py-4 sm:py-4',
        body: 'flex flex-col gap-4 px-4 py-2 sm:py-2',
        footer: 'text-sm gap-4 flex flex-row bg-neutral-100 rounded-b-[calc(var(--ui-radius)*2)] px-4 py-2',
      }"
    >
      <ConsentManagementPreferences v-model:open="is_open_preferences" />
      <template #header>
        <p v-text="t('comps.consent_modal.title')" />
      </template>
      <p
        class="max-md:text-xs md:text-sm break-words hyphens-auto"
        v-text="t('comps.consent_modal.text')"
      />
      <UButtonGroup
        size="md"
        class="w-full"
      >
        <UButton
          color="neutral"
          variant="subtle"
          class="flex justify-center w-full"
          :label="t('comps.consent_modal.btnPreferences')"
          @click="is_open_preferences = true"
        />
        <UButton
          class="flex justify-center w-full"
          :label="t('comps.consent_modal.btnAccept')"
          @click="cookies.allow(true)"
        />
      </UButtonGroup>
      <template #footer>
        <UButton
          variant="link"
          color="inherit"
          class="hover:!underline !no-underline"
          :label="t('privacyPolicy.btnLabel')"
          @click="showPrivacyPolicy()"
        />
        <UButton
          variant="link"
          color="inherit"
          class="hover:!underline !no-underline"
          :label="t('salesTerms.btnLabel')"
          @click="showSalesTerms()"
        />
      </template>
    </UCard>
  </ClientOnly>
</template>

<script setup lang="ts">
const cookies = useConsentStore()

const showSalesTermsModal = useState('showSalesTermsModal')
const showPrivacyModal = useState('showPrivacyModal')

function showSalesTerms() {
  showSalesTermsModal.value = true
}
function showPrivacyPolicy() {
  showPrivacyModal.value = true
}

const is_open_preferences = ref(false)
</script>
